var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":_vm.name}},[_c('span',{staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n      "+_vm._s(_vm.erro)+"\n    ")],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff4c6f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/concursos/edital/MensagemErro.vue
// module id = 0tcp
// module chunks = 15